import WishlistActiveHeartButtonIcon from '@/assets/svgExports/WishlistActiveHeartButtonIcon';
import WishlistHeartButtonIcon from '@/assets/svgExports/WishlistHeartButtonIcon';
import { useSelector } from 'react-redux';
import { WISHLIST_FEATURE_STATUS } from 'src/constants/wishlist';
import { useFeatureLocks } from 'src/hooks/useFeatureLocks';
import { RootState } from 'src/redux/reducers';

const WishlistHeartButton = ({ isActive, scale = 1, ...props }) => {
  const { wishlistFeatureActive } = useSelector((state: RootState) => ({
    wishlistFeatureActive: state.storeReducer?.store?.services?.wishlist_flag,
  }));
  const { wishlistFeatureStatus } = useFeatureLocks();
  return (
    wishlistFeatureActive === WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE && !wishlistFeatureStatus?.isLocked  && (
      <div
        className={`${props?.customClassName} ${props?.iconType && props?.iconType === "transparent" ? "" : "tw-transition-shadow tw-duration-200 hover:tw-shadow-[0_8px_20px_rgba(0,0,0,0.25)]"}`}
        style={{
          transform: `scale(${scale})`,
          lineHeight: 0,
          borderRadius: '50%',
        }}
      >
        {isActive ? (
          <WishlistActiveHeartButtonIcon {...props} />
        ) : (
          <WishlistHeartButtonIcon {...props} />
        )}
      </div>
    )
  );
};

export default WishlistHeartButton;
